import React, { Component } from 'react';
import { connect } from "react-redux";
import VehicleCell from '../Pages/Stakeholder/Vehicle/VehicleCell';
import ProfileCell from '../Pages/Stakeholder/User/ProfileCell';
import BookingDateAndTime from '../Common/Blocks/BookingDateAndTime';
import { openPullout } from '../../Actions/stakeholderActions';
import { VCIcon, DivisionIcon } from '../Common/Buttons/TypeIcons.js';

import axios from "axios";
import moment from "moment";
import { VCCheckoutAction, VCCheckinAction } from '../Common/Buttons/Icons';
import { Trans } from 'react-i18next';

//A React component will allow us to quickly iterate and change our code. It provides 
class ReleaseReturnRow extends Component {
    constructor(props) {
        super(props);

        this.releaseVehicle = this.releaseVehicle.bind(this);
        this.returnVehicle = this.returnVehicle.bind(this);
        this.viewOnCalendar = this.viewOnCalendar.bind(this);
        this.imageError = this.imageError.bind(this);

        this.state = {
        };
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {
    }

    releaseVehicle() {
        const element = document.getElementById(this.props.datatoggle);
        if (!element) return;

        element.classList.toggle('is-open');

        const base_url = (this.props.match.url).split('/')[1]
        this.props.history.push("/" + base_url + '/release/' + this.props.booking.BOOK_ID)
    }

    returnVehicle() {
        const element = document.getElementById(this.props.datatoggle);
        if (!element) return;

        element.classList.toggle('is-open');

        const base_url = (this.props.match.url).split('/')[1]
        this.props.history.push("/" + base_url + '/return/' + this.props.booking.BOOK_ID)
    }

    viewOnCalendar() {
        const element = document.getElementById(this.props.datatoggle);
        if (!element) return;

        element.classList.toggle('is-open');

        this.props.history.push("/bookings/info/" + this.props.booking.BOOK_ID)
        this.props.dispatch(openPullout(this.props.booking))
    }

    imageError(e) {
        e.target.src = this.props.settings.images.vehicle_placeholder_square.includes("images/") ? this.props.settings.images.vehicle_placeholder_square : "images/" + this.props.settings.images.vehicle_placeholder_square
    }

    render() {
        return (
            <div className = "alert-row" style={{display: "flex", height: '127px'}}>
                <div className = "float-left">
                    {
                        this.props.booking.vehicle.Photos != '' ?
                            <img className="alert-row-image" onError={this.imageError} src={'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_' + this.props.booking.vehicle.Photos} />
                        :
                            <img className="alert-row-image" src={this.props.settings.images.vehicle_placeholder_square.includes("images/") ? this.props.settings.images.vehicle_placeholder_square : "images/" + this.props.settings.images.vehicle_placeholder_square} />
                    }
                </div>
                <div className = "float-left">
                    <span className = "medium">{this.props.booking.vehicle.Year} {this.props.booking.vehicle.Make} {this.props.booking.vehicle.Model} {this.props.booking.vehicle.Trim}</span> is scheduled to be { this.props.booking.Released_On == null ? "released" : "returned" } on <span className = "medium">{ this.props.booking.Released_On == null ? (moment(this.props.booking.Start_Date ).format("MMM DD, YYYY") + " at " + moment(this.props.booking.Release_Time, "HH:mm:ss").format("h:mmA")) : (moment(this.props.booking.End_Date ).format("MMM DD, YYYY") + " at " + moment(this.props.booking.Return_Time, "HH:mm:ss").format("h:mmA")) }</span>
                    <div className = "clearfix"></div>
                    <span className = "caption"><Trans>To be released to</Trans> {this.props.booking.profile != null ? (this.props.booking.profile.First_Name != null ? this.props.booking.profile.First_Name : "") + " " + (this.props.booking.profile.Last_Name != null ? this.props.booking.profile.Last_Name : "") : "N/A" }</span>
                    <div className = "clearfix mb-8"></div>
                    {/* <a className = "link medium" onClick={this.viewOnCalendar}><Trans>See On Calendar</Trans></a> */}
                </div>
                <div style={{padding:'8px 6px', marginLeft: "auto", marginRight: "4px", display: "flex", flexWrap: "nowrap"}} className = "clearfix">
                    {VCIcon(this.props.booking.vehicle.vmh, null, null, null, true)}
                    {DivisionIcon(this.props.booking.vehicle.stakeholder, null, null, null, true)}
                </div>
                {
                    this.props.booking.has_servicing && this.props.userSession.user.has_booking_access ?
                        this.props.booking.Released_On === null ?
                            <div className = "alert-actions">
                                <div className = "button-group">
                                    <a className = "float-right" onClick={this.releaseVehicle} style={{marginTop: "5px"}}>
                                        {VCCheckoutAction("fill-primary")}
                                    </a>
                                </div>
                            </div>
                        :
                            <div className = "alert-actions">
                                <div className = "button-group">
                                    <a className="float-right" onClick={this.returnVehicle} style={{marginTop: "5px"}}>
                                        {VCCheckinAction("fill-primary")}
                                    </a>
                                </div>
                            </div>  
                    :
                        <span />
                }
                <div className = "clearfix"></div>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    stakeholder: store.stakeholder,
    settings: store.settings
});

export default connect(mapStateToProps)(ReleaseReturnRow);